import { render, staticRenderFns } from "./ImpactTest.vue?vue&type=template&id=b4994ab6&scoped=true&"
import script from "./ImpactTest.vue?vue&type=script&lang=js&"
export * from "./ImpactTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4994ab6",
  null
  
)

export default component.exports